require.context(
    "./data", // context folder
    true, // include subdirectories
    /^(?:(?!description\.json$|sections\.json$|resource\.json$).)*\.json$/ //get all json file except description.json and sections.json
);


require.context(
    "./data", // context folder
    true, // include subdirectories
    /^(?:(?!description\.csv$|sections\.csv$).)*\.csv$/
);

require.context(
    "./data",
    true,
    /^\.\/.*\.(jpg|jpeg|png)$/
);

require.context(
    "./data",
    true,
    /^\.\/.*\.(mp4|webm|ogv|3pg|flv)$/
);

// import 'babel-core/polyfill';
import 'babel-polyfill';
import React from 'react';

import {useBasename} from "history";

import {Provider} from 'react-redux';
import ReactDOM from 'react-dom';
import {Router, Route, IndexRoute, useRouterHistory} from 'react-router';
import {createHashHistory} from 'history'
import configureStore from './client/store/configureStore';
import App from './client/containers/App';
import DemoPage from './client/containers/DemoPage';
import HomePage from './client/containers/HomePage';
import QuickStart from './client/containers/QuickStart';
import {config} from './.temp/asset';

const appHistory = useRouterHistory(createHashHistory)({queryKey: false})
const store = configureStore();
const h1 = document.getElementById('spread-sheets');
h1.parentElement.removeChild(h1);
ReactDOM.render(
    <Provider store={store}>
        <Router history={appHistory}>
            <Route path="/" component={App}>
                <IndexRoute component={HomePage}/>
                <Route path="examples" groupName='examples'
                       component={DemoPage}>
                    <Route path=":demoId"
                           component={DemoPage}>
                    </Route>
                </Route>
                <Route path="demos" groupName="demos"
                       component={DemoPage}>
                    <Route path=":demoId"
                           component={DemoPage}>
                    </Route>
                </Route>
                <Route path="quickstart"
                       component={QuickStart}/>
                <Route path="*" component={HomePage}/>
            </Route>
        </Router>
    </Provider>,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./index.js